// @flow

import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getUserProfileRequest: null,
  getUserProfileSuccess: ['profile'],
  getUserProfileError: ['error'],
});

export const ProfileUserTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  error: undefined,
  fetching: false,
  profile: undefined,
});

/* ------------- Reducers ------------- */

export const userProfileRequest = (state: Object) => state.merge({
  fetching: true,
  userInfo: undefined,
  error: undefined
});

export const userProfileSuccess = (state: Object, {profile}: Object) => state.merge({
  fetching: false,
  error: undefined,
  profile
});

export const userProfileError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  profile: undefined
});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_USER_PROFILE_REQUEST]: userProfileRequest,
  [Types.GET_USER_PROFILE_SUCCESS]: userProfileSuccess,
  [Types.GET_USER_PROFILE_ERROR]: userProfileError
});
